<div class="react-wrapper">
  @if (!isLoaded() && !hasError()) {
    <div class="loading-message">
      <div class="spinner"></div>
    </div>
  }
  @if (hasError()) {
    <div class="error-message">
      <h3>⚠️App Loading Error</h3>
    </div>
  }
  <div #reactContainer class="react-app-container"></div>
</div>

